export const PalletReservationType = {
	FIFO: 1,
	FEFO: 2,
	FPFO: 3,
};
